import { Injectable } from "@angular/core";
import { Subject } from 'rxjs/Subject';
// import {Http, Headers} from "@angular/http";

// export const BASE_IMAGE_URL = 'http://bak.practice.com/';
// export const BACKEND_URL = 'http://bak.practice.com/';
@Injectable()
export class LoginUserService {

  private tokenSource = new Subject<string>();
  public token$ = this.tokenSource.asObservable();
  private userSource = new Subject<any>();
  public user$ = this.userSource.asObservable();


  private isLogined: boolean = false; //是否登录
  private isFirstLogin: boolean = false;  //判断是不是第一次登录
  private userInfo: any = {
    // id: 11,
    // type: '2',
    // name: '学生1',
    // headimg: '',
  };  //  用户登录信息

  constructor(// private _http: Http
  ) {
    let obj = localStorage.getItem('cshixi');
    if (obj) {
      this.setLogin(JSON.parse(obj));
    }
  }

  // hu ------------------------------------------------------------
  // 设置用户登录信息
  setLogin(obj) {
    if (!obj) {
      this.userInfo = {};
      this.isLogined = false;
      localStorage.clear();
      this.tokenSource.next('');
    } else {
      this.userInfo = obj;
      this.isLogined = true;
      localStorage.setItem('cshixi', JSON.stringify(obj));
      this.userInfo['is_first_login'].toString() === '0' ? this.isFirstLogin = true : this.isFirstLogin = false;
      this.tokenSource.next(obj.access_token);
    }
    this.userSource.next(obj);
    return this;
  }

  upImg(url: string) {
    if (this.isLogined) {
      switch ((this.userInfo['type'] + '')) {
        case '1':
          this.userInfo['headimg'] = url;
          break;
        case '3':
          this.userInfo['logo'] = url;
          break;
        default:
          console.log("用户类型不存在");
      }
      this.setLogin(this.userInfo);
    }
  }

  //判断是否在登录状态
  isLogin() {
    return this.isLogined;
    // setTimeout(() => {

    // }, 10);


  }

  //判断是否第一次登录
  isFistLogin() {
    return this.isFirstLogin;
  }

  //返回登录信息
  getLoginInfo() {
    return this.userInfo;
  }

  signOut() {
    this.userInfo = {};
    this.isLogined = false;
    this.isFirstLogin = null;
    localStorage.clear();
  }

  //-----------------------------------------------------------------
  setStorage(key: string, data: any) {
    // if(key == 'uinfo'){
    //     this._logined = data;
    // }
    // this._isAutoSignIn ? localStorage.setItem(key, JSON.stringify(data)) : sessionStorage.setItem(key, JSON.stringify(data));
  }

  //
  setLoginUser() {

  }

  setLoginInfo(obj: Object, isRemembered: boolean = false) {
    // if(this._isAutoSignIn){
    //     isRemembered = this._isAutoSignIn;
    // }
    // if (isRemembered) {
    //     this._isAutoSignIn = true;
    //     localStorage.setItem('uinfo', JSON.stringify(obj));
    // } else {
    //     this._isAutoSignIn = false;
    //     sessionStorage.setItem('uinfo', JSON.stringify(obj));
    // }
    // this._logined = obj;
    // this._isLogin = true;

  }

  getHeadimg() {
    // return this._logined['headimg'];
  }

  // 获取当前登陆用户的token
  getToken() {
    return this.userInfo.access_token;
    // return this._logined ? this._logined['token'] :'';
  }

  //
  getLoginUser() {
    // return this._logined;
  }



  updateExpire() {

    // let headers = new Headers();
    // headers.append('authorization', btoa(this._logined['token']));
    // this._http.get(BACKEND_URL + `/home/index/getExpire`, {headers: headers}).subscribe(resp => {
    //     let res = resp.json();
    //     this._logined['expire'] = res['session_expire'];
    // });
    // if (!this._isAutoSignIn) {
    //     sessionStorage.setItem('uinfo', JSON.stringify(this._logined));
    // } else {
    //     localStorage.setItem('uinfo', JSON.stringify(this._logined));
    // }
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/services/login-user.service.ts